module.exports = __webpack_public_path__ + "img/GelassenBeerig.6ad820b4.jpg";